import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ConfigurationService } from '../services/configuration.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const configService = inject(ConfigurationService);

  configService.enableLoader();

  return next(req).pipe(
    finalize(() => {
      configService.disableLoader();
    })
  );
};
